import { render, staticRenderFns } from "./FormatosColunas.vue?vue&type=template&id=6aee4b46&scoped=true"
import script from "./FormatosColunas.vue?vue&type=script&lang=js"
export * from "./FormatosColunas.vue?vue&type=script&lang=js"
import style0 from "./FormatosColunas.vue?vue&type=style&index=0&id=6aee4b46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aee4b46",
  null
  
)

export default component.exports